var render = function render(){var _vm=this,_c=_vm._self._c;return _c('path',{attrs:{"fill":"#212121","d":"M12,0C7.6,0,3,3.4,3,9c0,5.3,8,13.4,8.3,13.7c0.2,0.2,0.4,0.3,0.7,0.3s0.5-0.1,0.7-0.3C13,22.4,21,14.3,21,9 C21,3.4,16.4,0,12,0z M12,12c-1.7,0-3-1.3-3-3s1.3-3,3-3s3,1.3,3,3S13.7,12,12,12z"}})
}
var staticRenderFns = []

export { render, staticRenderFns }